import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiArrowLeft, HiEllipsisVertical } from 'react-icons/hi2';

export default function TopBar({ title, back, onBack, action, right }) {
  const navigate = useNavigate();

  return (
    <div className="top-bar">
      <div style={{ width: 40 }}>
        {back && (
          <button
            onClick={() => onBack ? onBack() : navigate(-1)}
            style={{
              background: 'rgba(255,255,255,0.07)',
              border: 'none',
              borderRadius: '12px',
              width: '38px',
              height: '38px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#fff',
            }}
            aria-label="Go back"
          >
            <HiArrowLeft size={18} />
          </button>
        )}
      </div>

      <span style={{ fontSize: '17px', fontWeight: 700, color: '#fff', letterSpacing: '-0.3px' }}>
        {title}
      </span>

      <div style={{ width: 40, display: 'flex', justifyContent: 'flex-end' }}>
        {(action ?? right) ?? <div style={{ width: 38 }} />}
      </div>
    </div>
  );
}
